import { motion, useReducedMotion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export function PageMasthead({ breadcrumb, title, subtitle }) {
  const reduce = useReducedMotion();
  const variants = reduce
    ? {}
    : {
        label: { initial: { opacity: 0 }, animate: { opacity: 1, transition: { duration: 0.4 } } },
        title: { initial: { opacity: 0, y: 18 }, animate: { opacity: 1, y: 0, transition: { duration: 0.5, delay: 0.1, ease: EASE } } },
        sub: { initial: { opacity: 0 }, animate: { opacity: 1, transition: { duration: 0.5, delay: 0.25 } } },
        line: { initial: { scaleX: 0 }, animate: { scaleX: 1, transition: { duration: 0.6, delay: 0.35, ease: EASE } } },
      };

  return (
    <section
      className="relative bg-piks-black text-white overflow-hidden pt-24 pb-8 sm:pt-28 sm:pb-10 min-h-[150px] sm:min-h-[200px] flex items-center"
      data-testid="page-masthead"
    >
      <img
        src="/piks-logo.png?v=7"
        alt=""
        className="crest-watermark absolute -right-10 top-1/2 -translate-y-1/2 w-[280px] sm:w-[380px] object-contain select-none"
      />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full">
        <motion.p
          {...(variants.label || {})}
          className="font-mono text-[11px] font-semibold tracking-[0.25em] text-piks-gold/80 mb-3"
          data-testid="masthead-breadcrumb"
        >
          BODYGUARD SARAWAK / {breadcrumb}
        </motion.p>
        <motion.h1
          {...(variants.title || {})}
          className="font-display text-[clamp(2rem,5vw,3.6rem)] font-extrabold leading-[1.05] mb-3"
          data-testid="masthead-title"
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p {...(variants.sub || {})} className="text-white/60 max-w-xl text-sm sm:text-base" data-testid="masthead-subtitle">
            {subtitle}
          </motion.p>
        )}
        <motion.div
          {...(variants.line || {})}
          className="mt-6 h-[2px] w-32 bg-gradient-to-r from-piks-red via-piks-gold to-transparent origin-left"
        />
      </div>
    </section>
  );
}
